import React, {useState, useRef, useEffect} from "react";
import {useSelector} from "react-redux";
import {message, Breadcrumb, Form, Row, Col, Input, InputNumber, Space, Button, Select} from "antd";
import {LeftCircleOutlined, FileDoneOutlined} from "@ant-design/icons";
import ChuangShiOS from "chuangshi-os-website-component";

import Application from "../../common/Application";

import Style from "./Detail.module.css";

const CityDetail = (props) => {
    const store = useSelector((store) => store);
    const [form] = Form.useForm();
    const request = useRef(false);
    const [isLoad, setIsLoad] = useState(false);
    const [isError, setIsError] = useState(false);
    const [isSave, setIsSave] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [systemVersion, setSystemVersion] = useState(0);
    const [provinceList, setProvinceList] = useState([]);

    useEffect(() => {
        if (store.main.userName) {
            ChuangShiOS.Notification.emit("main_menu_active", {url: "/city/index"});

            handleLoadProvince();

            switch (props.match.path) {
                case "/city/add":
                    setIsSave(true);

                    break;
                case "/city/edit/:cityId":
                    setIsEdit(true);

                    handleLoadCity();

                    break;
                default:
                    break;
            }
        }

        //eslint-disable-next-line
    }, [store.main.userName]);

    const handleLoadProvince = () => {
        ChuangShiOS.Util.request(props, {
            url: Application.host + "/windeal/province/business/website/v1/select/list",
            data: {},
            success: (response) => {
                setProvinceList(response.data);
            },
            error: (response) => {
                message.error({content: response.message, duration: 1});
            },
            complete: (response) => {},
        });
    };

    const handleLoadCity = () => {
        if (request.current) {
            return;
        }
        request.current = true;

        setIsLoad(true);

        ChuangShiOS.Util.request(props, {
            url: Application.host + "/windeal/city/business/website/v1/find",
            data: {
                cityId: props.match.params.cityId,
            },
            success: (response) => {
                form.setFieldsValue(response.data);

                setSystemVersion(response.data.systemVersion);
            },
            error: (response) => {
                message.error({content: response.message, duration: 1});
            },
            complete: (response) => {
                request.current = false;

                setIsLoad(false);
                setIsError(typeof response.data == "undefined" || typeof response.data.cityId == "undefined" || response.data.cityId == null);
            },
        });
    };

    const handleSubmitCity = () => {
        if (request.current) {
            return;
        }

        form.validateFields()
            .then((data) => {
                if (request.current) {
                    return;
                }
                request.current = true;

                setIsLoad(true);

                message.loading({
                    content: "正在加载",
                    key: "isLoad",
                    duration: 0,
                });

                data.cityId = props.match.params.cityId;
                data.systemVersion = systemVersion;

                let url = "";
                if (isSave) {
                    url = "/windeal/city/business/website/v1/save";
                }
                if (isEdit) {
                    url = "/windeal/city/business/website/v1/update";
                }

                ChuangShiOS.Util.request(props, {
                    url: Application.host + url,
                    data: data,
                    success: (response) => {
                        message.success({
                            content: response.message,
                            key: "isLoad",
                            duration: 2,
                        });

                        request.current = false;

                        setIsLoad(false);

                        ChuangShiOS.Util.navigateBack(props, {});
                    },
                    error: (response) => {
                        message.error({
                            content: response.message,
                            key: "isLoad",
                            duration: 2,
                        });

                        request.current = false;

                        setIsLoad(false);
                    },
                    complete: (response) => {},
                });
            })
            .catch((response) => {
                ChuangShiOS.Util.parseResponseError(response);
            });
    };

    const handleBackCity = () => {
        ChuangShiOS.Util.navigateBack(props, {});
    };

    return (
        <div className={Style.page}>
            <div className={Style.header}>
                <div className={Style.header_title}>
                    <Breadcrumb>
                        <Breadcrumb.Item>
                            <span>首页</span>
                        </Breadcrumb.Item>
                        <Breadcrumb.Item>
                            <span>{store.main.menuName}</span>
                        </Breadcrumb.Item>
                    </Breadcrumb>
                    <div className={Style.header_title_text}>{store.main.sidebarName}</div>
                </div>
                <div className={Style.header_button}>
                    <Space>
                        <Button.Group>
                            <Button icon={<LeftCircleOutlined />} size="large" onClick={handleBackCity}>
                                返回
                            </Button>
                        </Button.Group>
                        <Button
                            loading={isLoad}
                            disabled={isError}
                            icon={<FileDoneOutlined />}
                            type="primary"
                            size="large"
                            onClick={handleSubmitCity}
                        >
                            提交
                        </Button>
                    </Space>
                </div>
            </div>
            <ChuangShiOS.Content
                className={Style.content}
                isLoad={isLoad}
                isEmpty={false}
                isError={isError}
                paddingTop={28}
                isScroll={store.main.isFixedContent}
            >
                <Row>
                    <Col flex="auto">
                        <div className={Style.card_title}>基本信息</div>
                    </Col>
                    <Col></Col>
                </Row>
                <Form form={form}>
                    <Row>
                        <Col span={12}>
                            <Form.Item
                                {...{
                                    labelCol: {flex: "24%"},
                                    wrapperCol: {flex: "auto"},
                                }}
                                label="所属省份"
                                name="provinceId"
                                initialValue={null}
                                rules={[
                                    {
                                        required: true,
                                        message: "请选择所属省份",
                                    },
                                ]}
                            >
                                <Select className={Style.card_field} placeholder="请选择所属省份" allowClear onChange={() => {}}>
                                    {provinceList.map((province, provinceIndex) => {
                                        return (
                                            <Select.Option key={provinceIndex} value={province.provinceId}>
                                                {province.provinceName}
                                            </Select.Option>
                                        );
                                    })}
                                </Select>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={12}>
                            <Form.Item
                                {...{
                                    labelCol: {flex: "24%"},
                                    wrapperCol: {flex: "auto"},
                                }}
                                label="城市名称"
                                name="cityName"
                                initialValue={""}
                                rules={[
                                    {
                                        required: true,
                                        message: "请输入城市名称",
                                    },
                                ]}
                            >
                                <Input className={Style.card_field} placeholder="请输入城市名称" onPressEnter={handleSubmitCity} />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={12}>
                            <Form.Item
                                {...{
                                    labelCol: {flex: "24%"},
                                    wrapperCol: {flex: "auto"},
                                }}
                                label="城市代码"
                                name="cityCode"
                                initialValue={""}
                                rules={[
                                    {
                                        required: true,
                                        message: "请输入城市代码",
                                    },
                                ]}
                            >
                                <Input className={Style.card_field} placeholder="请输入城市代码" onPressEnter={handleSubmitCity} />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={12}>
                            <Form.Item
                                {...{
                                    labelCol: {flex: "24%"},
                                    wrapperCol: {flex: "auto"},
                                }}
                                label="城市排序"
                                name="citySort"
                                initialValue={0}
                                rules={[
                                    {
                                        required: true,
                                        message: "请输入城市排序",
                                    },
                                ]}
                            >
                                <InputNumber
                                    className={Style.card_field}
                                    min={0}
                                    max={999999}
                                    placeholder="请输入城市排序"
                                    onPressEnter={handleSubmitCity}
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            </ChuangShiOS.Content>
            <div className={Style.footer}></div>
        </div>
    );
};

CityDetail.propTypes = {};

CityDetail.defaultProps = {};

export default CityDetail;
